<script>
import Video from './Video';
import VideoRectangleTile from './VideoRectangleTile';
import VideoLoading from './VideoLoading';
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'VideoModal',
  components: {
    Video,
    VideoRectangleTile,
    VideoLoading,
  },
  directives: {
    ClickOutside,
  },
  props: {
    videoId: {
      type: String,
      required: true,
    },
    videoTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedVideoId: '',
      selectedVideoTitle: '',
      viewportWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters({
      videoDetails: 'VideoTiles/getVideoDetails',
    }),
    relatedVideos() {
      return this.videoDetails.relatedVideos;
    },
    relatedVideosExist() {
      const { relatedVideos } = this.videoDetails;
      return relatedVideos ? relatedVideos.length > 0 : false;
    },
    isMobile() {
      return this.viewportWidth < 768;
    },
  },
  mounted() {
    const { videoId, videoTitle, getSelectedVideo, setWindowWidth } = this;
    getSelectedVideo(videoId, videoTitle);
    window.addEventListener('resize', this.handleResize);
    setWindowWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getSelectedVideo(selectedId, selectedTitle) {
      const { $store: store, selectedVideoId } = this;
      // set the new video ID and title
      // while fetching for new related videos
      // do nothing if same video ID
      if (selectedVideoId !== selectedId) {
        this.selectedVideoId = selectedId;
        this.selectedVideoTitle = selectedTitle;
        store.dispatch('VideoTiles/fetchVideo', selectedId);
      }
    },
    closeModal() {
      this.$emit('closeModal');
    },
    setWindowWidth() {
      this.viewportWidth = window.innerWidth;
    },
    handleResize() {
      this.setWindowWidth();
    },
  },
};
</script>

<template>
  <transition name="modal">
    <div class="modal-mask">
      <div :class="[{ 'modal-mobile': isMobile }]" class="modal-wrapper">
        <div v-click-outside="closeModal" class="modal-container">
          <div class="modal-close" @click.prevent="closeModal">
            <a href="/">&times;</a>
          </div>
          <!-- Selected Video -->
          <div class="modal-video">
            <Video
              :key="selectedVideoId"
              :videoId="selectedVideoId"
              :videoTitle="selectedVideoTitle"
            ></Video>
          </div>
          <div class="modal-related-videos">
            <h3 class="modal-related-videos__title">Latest Video</h3>
            <div
              :class="[{ 'modal-related-videos__container__mobile': isMobile }]"
              class="modal-related-videos__container"
            >
              <!-- Loading -->
              <VideoLoading v-if="!relatedVideosExist"/>
              <!-- List of related videos -->
              <template v-else>
                <a
                  v-for="(relatedVid, index) in relatedVideos"
                  :key="`rel-video-tile-${index}`"
                  href="/"
                  class="related-tile-transition"
                  @click.prevent="getSelectedVideo(relatedVid.id, relatedVid.title)"
                >
                  <VideoRectangleTile
                    :video-id="relatedVid.id"
                    :video-title="relatedVid.title"
                    :video-image-url="relatedVid.images.poster"
                    :video-duration="relatedVid.duration"
                    :video-published-at="relatedVid.published_at"
                  />
                </a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
